import axios from 'utils/axios';
import type {
    GetObjectBaseReportResultType,
    GetTeamBaseReportResultType,
    GetUserIncomeReportResultType,
} from '@econtractor/types';
import type { ReportVatFilter } from 'modules/admin';

export const get4Objects = async (
    fromDate: number,
    toDate: number,
    isVat: ReportVatFilter,
    includeObjects = true,
    includeSales = true,
): Promise<GetObjectBaseReportResultType | null> => {
    try {
        const response = await axios(`/reports/objects/${fromDate}/${toDate}`, {
            params: {
                isVat,
                includeObjects: includeObjects ? 1 : 0,
                includeSales: includeSales ? 1 : 0,
            },
        });
        return response.data;
    } catch (e) {
        console.error(e);
        return null;
    }
};

export const get4Teams = async (
    fromDate: number,
    toDate: number,
): Promise<GetTeamBaseReportResultType | null> => {
    try {
        const response = await axios(`/reports/teams/${fromDate}/${toDate}`);
        return response.data;
    } catch (e) {
        console.error(e);
        return null;
    }
};

export const get4Users = async (
    fromDate: number,
    toDate: number,
): Promise<GetUserIncomeReportResultType | null> => {
    try {
        const response = await axios(`/reports/users/${fromDate}/${toDate}`);
        return response.data;
    } catch (e) {
        console.error(e);
        return null;
    }
};
